import { render, staticRenderFns } from "./BoardMembers.vue?vue&type=template&id=6d011ca3&"
import script from "./BoardMembers.vue?vue&type=script&lang=js&"
export * from "./BoardMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports